export enum INVITE_STATUS {
  accepted = 'accepted',
  pending = 'pending',
  uninvited = 'uninvited',
  duplicated = 'duplicated',
  duplicatedPending = 'duplicated pending',
  coManagerRequestPending = 'co-manager request pending',
}

export enum INVITE_STATUS_NAMES {
  accepted = 'Accepted',
  pending = 'Pending',
  uninvited = 'Not yet invited',
  duplicated = 'Duplicate',
}
